/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StrategyPlaygroundSession } from '../../models/strategy-playground-session';

export interface GetTeamSessions$Json$Params {
  companyGuid?: string;
  teamSessionName?: string;
}

export function getTeamSessions$Json(http: HttpClient, rootUrl: string, params?: GetTeamSessions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StrategyPlaygroundSession>>> {
  const rb = new RequestBuilder(rootUrl, getTeamSessions$Json.PATH, 'get');
  if (params) {
    rb.query('companyGuid', params.companyGuid, {});
    rb.query('teamSessionName', params.teamSessionName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StrategyPlaygroundSession>>;
    })
  );
}

getTeamSessions$Json.PATH = '/design/teamsession';
